import { Box, Typography } from '@mui/material'

/** Under-chart context (row 25): active filters + grouping. Inside the export-captured
 *  element so pins/PNG/PDF carry the context. Renders nothing when there is none. */
export function ChartContextCaption({ lines }: { lines: string[] }) {
  if (lines.length === 0) return null
  return (
    <Box data-testid="chart-context-caption">
      {lines.map((line, i) => (
        <Typography key={i} variant="caption" color="text.secondary" sx={{ display: 'block' }}>
          {line}
        </Typography>
      ))}
    </Box>
  )
}
